var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 414,
    height: 61,
    viewBox: "0 0 414 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5008 42.6111H1.5V1.5H412V42.6111H151.501H48.5008V56.5L37.5008 42.6111Z",
    fill: "#e7eef7",
    stroke: "#e7eef7",
    strokeWidth: 3,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardHeader);
export default __webpack_public_path__ + "static/media/card-header.91061e91d175ac33a9e9223665ac2dc8.svg";
export { ForwardRef as ReactComponent };